<template>
  <div class="skeleton">
    <Retry
      v-if="loading === -1"
      message="Failed to load game data. Please retry."
      :is-page="false"
      @retry="onRetry"
    />
    <template v-else-if="loading">
      <div class="loading-container">
        <IconLoading />
      </div>
    </template>

    <template v-else>
      <slot name="top" />
      <slot>
        <!-- empty data -->
        <Empty :size="emptySize" />
      </slot>
    </template>
  </div>
</template>

<script>
/* 骨架屏 */
import Retry from 'wap/components/Retry'
import Empty from 'wap/components/Empty'
import IconLoading from 'fe-vui/IconLoading'

export default {
  name: 'Skeleton',
  components: {
    Retry,
    Empty,
    IconLoading
  },
  props: {
    loading: {
      type: [Boolean, Number],
      default: true
    },
    // retry size 类型
    emptySize: {
      type: String,
      default: 'normal'
    }
  },
  methods: {
    onRetry() {
      this.$emit('retry')
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.skeleton {
  .loading-container {
    position: relative;
    height: 32/@rem;
    padding: 67/@rem 0;
    color: #999;
    text-align: center;
  }
}
</style>
